(() => {
  if (customElements.get('wcf-measurement-video')) return;
  customElements.define('wcf-measurement-video', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.abort = new AbortController();
      const on = (el, type, fn) => el.addEventListener(type, fn, {signal:this.abort.signal});
      const panel = this.querySelector('.wcf-video-window');
      const opener = this.querySelector('.wcf-video-open');
      const video = panel.querySelector('video');
      const safeControls = panel.hasAttribute('data-wcf-video-refresh-20261102');
      const drag = panel.querySelector('.wcf-video-drag');
      const resize = panel.querySelector('[data-video-resize]');
      const close = panel.querySelector('[data-video-close]');
      const fullscreen = panel.querySelector('[data-video-fullscreen]');
      this.panel = panel; this.opener = opener;
      document.body.append(panel);
      const scope = document.getElementById('shopify-section-' + this.dataset.sectionId) || this.closest('product-info') || this.parentElement;
      const attach = () => {
        const anchor = scope.querySelector('.expo-steps-trigger-wrap') || scope.querySelector('[data-wcf-measure]');
        const trigger = anchor?.querySelector('.expo-steps-trigger, [data-measure-open]');
        if (!trigger) return;
        anchor.classList.add('wcf-video-anchor');
        if (opener.parentElement !== anchor) trigger.insertAdjacentElement('afterend', opener);
        opener.hidden = false;
      };
      this.observer = new MutationObserver(attach);
      this.observer.observe(scope, {childList:true, subtree:true}); attach();
      let backdrop=null, previousOverflow=null;
      const modal = (enabled) => {
        if (!safeControls) return;
        if (enabled && !backdrop) {
          previousOverflow=document.body.style.overflow;
          document.body.style.overflow='hidden';
          backdrop=document.createElement('div');backdrop.className='wcf-video-large-backdrop';
          document.body.insertBefore(backdrop,panel);
          panel.setAttribute('role','dialog');panel.setAttribute('aria-modal','true');
        } else if (!enabled && backdrop) {
          backdrop.remove();backdrop=null;document.body.style.overflow=previousOverflow;previousOverflow=null;
          panel.setAttribute('role','region');panel.removeAttribute('aria-modal');
        }
      };
      this.cleanupLargeModal=()=>modal(false);
      const bounds = () => ({left:window.visualViewport?.offsetLeft || 0,top:window.visualViewport?.offsetTop || 0,width:window.visualViewport?.width || innerWidth,height:window.visualViewport?.height || innerHeight});
      const place = (x,y) => {
        const b=bounds(),r=panel.getBoundingClientRect();
        panel.style.left=Math.max(b.left+8,Math.min(x,b.left+b.width-r.width-8))+'px';
        panel.style.top=Math.max(b.top+8,Math.min(y,b.top+b.height-r.height-8))+'px';
        panel.style.right='auto';panel.style.bottom='auto';
      };
      const clamp = () => {if(!panel.hidden&&!panel.classList.contains('is-expanded')&&document.fullscreenElement!==panel){const r=panel.getBoundingClientRect(),b=bounds();if(safeControls&&!panel.classList.contains('is-small'))place(b.left+(b.width-r.width)/2,b.top+(b.height-r.height)/2);else place(r.left,r.top);}};
      const sizeVideo = () => {
        if (!safeControls || panel.hidden) return;
        const b=bounds(), header=panel.querySelector('.wcf-video-header'), toolbar=panel.querySelector('.wcf-video-toolbar');
        const availableHeight=Math.max(65,b.height-header.offsetHeight-toolbar.offsetHeight-16);
        const ratio=(video.videoWidth && video.videoHeight) ? video.videoWidth/video.videoHeight : 16/9;
        const width=Math.max(1,Math.min(panel.clientWidth,(availableHeight-64)*ratio));
        const height=width/ratio+64;
        const w=width.toFixed(2)+'px', h=height.toFixed(2)+'px';
        if (video.style.getPropertyValue('--wcf-safe-video-width')!==w) video.style.setProperty('--wcf-safe-video-width',w);
        if (video.style.getPropertyValue('--wcf-safe-video-height')!==h) video.style.setProperty('--wcf-safe-video-height',h);
      };
      if (safeControls && window.ResizeObserver) {
        this.videoResizeObserver=new ResizeObserver(()=>{sizeVideo();clamp();});
        this.videoResizeObserver.observe(panel);
      }
      const expandPage = (expanded) => {
        panel.classList.toggle('is-expanded',expanded);
        fullscreen.textContent=expanded?fullscreen.dataset.exitLabel:fullscreen.dataset.enterLabel;
        fullscreen.setAttribute('aria-pressed',String(expanded));
        sizeVideo(); if(!expanded)clamp();
      };
      on(fullscreen,'click',()=>{
        if(panel.classList.contains('is-expanded')){expandPage(false);return;}
        if(safeControls && document.fullscreenElement===panel){document.exitFullscreen?.();return;}
        const fallback=()=>{if(!panel.hidden)expandPage(true);};
        try{
          if(safeControls && typeof panel.requestFullscreen==='function'){
            const result=panel.requestFullscreen();
            result?.catch(fallback);
          }else if(safeControls){fallback();
          }else if(typeof video.requestFullscreen==='function'){
            const result=video.requestFullscreen();
            result?.catch(fallback);
          }else if(typeof video.webkitEnterFullscreen==='function'){
            video.webkitEnterFullscreen();
          }else fallback();
        }catch{fallback();}
      });
      on(document,'fullscreenchange',()=>{if(safeControls){const active=document.fullscreenElement===panel || panel.classList.contains('is-expanded');fullscreen.textContent=active?fullscreen.dataset.exitLabel:fullscreen.dataset.enterLabel;fullscreen.setAttribute('aria-pressed',String(active));}sizeVideo();clamp();});
      on(video,'webkitendfullscreen',clamp);
      const hide = () => {if(safeControls && document.fullscreenElement===panel)document.exitFullscreen?.();video.pause();expandPage(false);modal(false);panel.hidden=true;opener.setAttribute('aria-expanded','false');opener.focus({preventScroll:true});};
      on(opener,'click',()=>{panel.classList.remove('is-small');resize.setAttribute('aria-pressed','false');resize.textContent='↙';panel.hidden=false;modal(true);opener.setAttribute('aria-expanded','true');sizeVideo();if(safeControls){const b=bounds(),r=panel.getBoundingClientRect();place(b.left+(b.width-r.width)/2,b.top+(b.height-r.height)/2);}else clamp();close.focus({preventScroll:true});video.play().catch(()=>{});});
      on(close,'click',hide);
      on(panel,'keydown',e=>{if(safeControls && backdrop && e.key==='Tab'){const focusable=[...panel.querySelectorAll('button:not([disabled]),video[controls]')].filter(el=>el.getClientRects().length);if(focusable.length){const first=focusable[0],last=focusable[focusable.length-1];if(e.shiftKey && document.activeElement===first){e.preventDefault();last.focus();}else if(!e.shiftKey && document.activeElement===last){e.preventDefault();first.focus();}}}if(e.key==='Escape'){e.stopPropagation();if(panel.classList.contains('is-expanded')){expandPage(false);fullscreen.focus();}else hide();}});
      on(resize,'click',()=>{const small=panel.classList.toggle('is-small');modal(!small);resize.setAttribute('aria-pressed',String(small));resize.textContent=small?'↗':'↙';sizeVideo();clamp();});
      on(video,'error',()=>{panel.querySelector('.wcf-video-error').hidden=false;});
      on(video,'loadedmetadata',()=>{sizeVideo();clamp();});
      let pointer=null;
      on(drag,'pointerdown',e=>{if(e.button!==0||panel.classList.contains('is-expanded')||(safeControls && document.fullscreenElement===panel))return;const r=panel.getBoundingClientRect();pointer={id:e.pointerId,x:e.clientX-r.left,y:e.clientY-r.top};drag.setPointerCapture(e.pointerId);});
      on(drag,'pointermove',e=>{if(pointer?.id===e.pointerId)place(e.clientX-pointer.x,e.clientY-pointer.y);});
      on(drag,'pointerup',()=>{pointer=null;});on(drag,'pointercancel',()=>{pointer=null;});
      on(drag,'keydown',e=>{if(safeControls && document.fullscreenElement===panel)return;const steps={ArrowLeft:[-20,0],ArrowRight:[20,0],ArrowUp:[0,-20],ArrowDown:[0,20]};if(steps[e.key]){e.preventDefault();const r=panel.getBoundingClientRect();place(r.left+steps[e.key][0],r.top+steps[e.key][1]);}});
      on(window,'resize',()=>{sizeVideo();clamp();});
      if(window.visualViewport){on(window.visualViewport,'resize',()=>{sizeVideo();clamp();});on(window.visualViewport,'scroll',clamp);}
    }
    disconnectedCallback(){this.cleanupLargeModal?.();this.abort?.abort();this.observer?.disconnect();this.videoResizeObserver?.disconnect();this.panel?.querySelector('video')?.pause();this.panel?.remove();this.opener?.remove();this.ready=false;}
  });
})();
